import React from "react";
import { ToastContainer } from "react-toastify";
import ViewCustomers from "../../components/Customers/ViewCustomers";

export const ViewCustomerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewCustomers />
        </div>
      </div>
    </div>
  );
};
